/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { App } from "./App";
export const AppResponse = core.serialization.object({
    data: App,
});
